var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.location)?_c('GmapMap',{ref:"gmap",style:(`width: 100%; height: ${_vm.mapHeight}`),attrs:{"center":_vm.location,"zoom":_vm.zoom}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }